import { HIT_TYPE, EVENT_NAMES, TARGETS } from 'app-webtech-core/beacon/const';
import { getPlaybackData } from './helpers/getPlaybackData';

/*
 */

export const enterFullScreenBeacon = (action, prevState, nextState) => ({
  hitType: HIT_TYPE.EVENT,
  targets: TARGETS.MSN,
  eventName: EVENT_NAMES.ENTER_FULL_SCREEN,
  ...getPlaybackData(nextState),
});
